import { HTTP } from '@ionic-native/http/ngx';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ComponentsModule } from './components/components.module';
import { ModalComponents } from './modal-components/modal-component.module';
import { BrowserTab } from '@ionic-native/browser-tab/ngx';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { ResizableModule } from 'angular-resizable-element';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { PipesModule } from 'src/app/pipe/pipes.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpLoaderFactory } from '../util/translateLoader';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { CalendarModule } from 'ion2-calendar';
import { AuthorizationInterceptor } from './interceptors/authorization.interceptor';

@NgModule({
    declarations: [AppComponent],
    entryComponents: [],
    imports: [
        BrowserModule,
        IonicModule.forRoot(),
        AppRoutingModule,
        ComponentsModule,
        ModalComponents,
        HttpClientModule,
        ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
        ResizableModule,
        InfiniteScrollModule,
        PipesModule,
        PdfViewerModule,
        CalendarModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            },
        }),
    ],
    providers: [
        StatusBar,
        SplashScreen,
        InAppBrowser,
        BrowserTab,
        HTTP,
        {
            provide: RouteReuseStrategy,
            useClass: IonicRouteStrategy
        },
        { provide: HTTP_INTERCEPTORS, useClass: AuthorizationInterceptor, multi: true },
    ],
    bootstrap: [AppComponent]
})

export class AppModule {
}
